import { CareersFormValues } from 'app/careers/(positions)/CareersFormValues'

export const submitForm = async (data: CareersFormValues): Promise<boolean> => {
  const formData = new FormData()
  const form = {
    positionId: data.positionId,
    positionName: data.positionName,
    fullName: data.fullName,
    email: data.email,
    about: data.about,
    interests: data.interests,
    level: data.level,
    token: data.token,
  }

  if (data.files) {
    for (let i = 0; i < data.files.length; i++) {
      formData.append('files', data.files[i], data.files[i].name)
    }
  }

  formData.append('data', JSON.stringify(form))

  const response = await fetch('/api/careers', {
    method: 'POST',
    body: formData,
  })

  return response.ok
}
